import { ReactNode } from 'react';

interface Props {
  /** What this screen is for, under the wordmark. */
  subtitle: string;
  children: ReactNode;
}

/** The centred card every unauthenticated screen sits in. */
export function AuthShell({ subtitle, children }: Props) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4 py-10">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold tracking-tight text-brand-600 dark:text-brand-400">PulseCheck</h1>
          <p className="text-gray-500 dark:text-gray-400 mt-2">{subtitle}</p>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-card border border-gray-200 dark:border-gray-700 p-8">
          {children}
        </div>
      </div>
    </div>
  );
}
